import React from 'react';
import Grid from '@material-ui/core/Grid';
import Skeleton from '@material-ui/lab/Skeleton';
import { DIMENSIONS } from './../../../styles/constants';
import { useStyles } from './../styles';
import Paper from '@material-ui/core/Paper';

const WdValidatorSkeleton = () => {
	const classes = useStyles();

	return (
		<Paper className={classes.paper}>
			<Grid container spacing={1}>
				<Grid container justifyContent="space-between">
					<Grid className={classes.firstColumn}>
						<Skeleton width="60%" height={DIMENSIONS.SKELETON_BUTTON_HEIGHT} />
						<Skeleton width="50%" height={DIMENSIONS.SKELETON_BUTTON_HEIGHT} />
						<Skeleton width="50%" height={DIMENSIONS.SKELETON_BUTTON_HEIGHT} />
					</Grid>
					<Grid className={classes.secondColumn}>
						<Skeleton width="50%" height={DIMENSIONS.SKELETON_BUTTON_HEIGHT} />
						<Skeleton width="50%" height={DIMENSIONS.SKELETON_BUTTON_HEIGHT} />
					</Grid>

					<Grid className={classes.thirdColumn}>
						<Skeleton width="60%" height={DIMENSIONS.SKELETON_BUTTON_HEIGHT} />
					</Grid>
					<Grid className={classes.fourthColumn}>
						<Skeleton width="100%" className={classes.evalButton} height={DIMENSIONS.NAVBAR_HEIGHT} />
					</Grid>
				</Grid>
			</Grid>
		</Paper>
	);
};

export default WdValidatorSkeleton;
